module.exports = __webpack_public_path__ + "img/heart.2ba7887d.svg";